export default "__VITE_ASSET__2df992a4__"